<template>
	<div id="container">
		<div class="mainTitle"><input type="text" v-model="tabsList.title" placeholder="名称" /></div>
		<ul class="dialogHeader">
			<li @click="addPage">添加分页</li>
			<li @click="closeAdmin">关闭页面</li>
			<li @click="submitForm">提交表单</li>
		</ul>
		<div class="contentClass">
			<div class="leftTabs">
				<!-- 添加字段 -->
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="添加字段" name="first">
						<ul class="tabsUl">
							<li v-for="(item, leftIndex) in ulTabs" :key="leftIndex" @click="leftTabClick(leftIndex)">
								<i class="el-icon-circle-plus-outline"></i>
								<span>{{ item }}</span>
							</li>
						</ul>
					</el-tab-pane>
					<!-- 编辑字段 -->
					<el-tab-pane label="编辑字段" name="second">
						<div class="editContent">
							<div v-for="(item, index) in tabsList.formDesignPageList" :key="index">
								<!-- 分段 -->
								<div v-for="(item1, index) in item.formDesignFieldList" :key="index" v-show="contentId == item1.formId">
									<!--  v-show="contentId==item1.formId" -->
									<div class="contentOne" v-if="item1.status == leftIndex" v-show="leftIndex == 0">
										<div class="contentChild">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入内容"></el-input>
										</div>
									</div>
									<!-- 文本 -->
									<div class="contentOne" v-if="item1.status == leftIndex" v-show="leftIndex == 1">
										<p>文本内容</p>
										<el-input :name="item1.key" v-model="item1.label" type="textarea" placeholder="请输入内容"></el-input>
										<!-- <div class="saveChage">保存更改</div> -->
									</div>
									<!-- 文本输入框 -->
									<div class="contentOne" v-if="item1.status == leftIndex" v-show="leftIndex == 2">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p>长度限制</p>
											<div class="lengthClass">
												<el-input-number
													:name="item1.key"
													v-model="item1.minLength"
													controls-position="right"
													@change="handleChange1"
													:min="0"
													:max="100000"
												></el-input-number>
												<span>-</span>
												<el-input-number
													:name="item1.key"
													v-model="item1.maxLength"
													controls-position="right"
													@change="handleChange2"
													:min="0"
													:max="100000"
												></el-input-number>
											</div>
										</div>
									</div>
									<!-- 密码输入框 -->
									<div class="contentOne" v-if="item1.status == leftIndex" v-show="leftIndex == 3">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p>长度限制</p>
											<div class="lengthClass">
												<el-input-number
													:name="item1.key"
													v-model="item1.minLength"
													controls-position="right"
													@change="handleChange3"
													:min="0"
													:max="1000000"
												></el-input-number>
												<span>-</span>
												<el-input-number
													:name="item1.key"
													v-model="item1.maxLength"
													controls-position="right"
													@change="handleChange4"
													:min="0"
													:max="1000000"
												></el-input-number>
											</div>
										</div>
									</div>
									<!-- 数值输入框 -->
									<div class="contentOne" v-if="item1.status == leftIndex" v-show="leftIndex == 4">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<!-- <div class="saveChage">保存更改</div> -->
										</div>
									</div>
									<!-- 日期选择框 -->
									<div class="contentOne" v-if="item1.status == leftIndex" v-show="leftIndex == 5">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
										</div>
									</div>
									<!-- 多行文本输入框 -->
									<div class="contentOne" v-if="item1.status == leftIndex" v-show="leftIndex == 6">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p>长度限制</p>
											<div class="lengthClass">
												<el-input-number
													:name="item1.key"
													v-model="item1.minLength"
													controls-position="right"
													@change="handleChange5"
													:min="0"
													:max="10000000000"
												></el-input-number>
												<span>-</span>
												<el-input-number
													:name="item1.key"
													v-model="item1.maxLength"
													controls-position="right"
													@change="handleChange6"
													:min="0"
													:max="100000000"
												></el-input-number>
											</div>
										</div>
									</div>
									<!-- 下拉列表 -->
									<div class="contentOne" v-show="leftIndex == 7" v-if="item1.status == leftIndex">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p class="select">
												<span>选项</span>
												<span @click="dialogFormVisible = true">字典选择</span>
												<!-- 点击字典选择时把数据push到列表 -->
											</p>
											<div class="opyionClass">
												<ul>
													<li v-for="(item2, index) in item1.options" :key="index">
														<p>
															<el-input :name="item2.key" v-model="item2.label" placeholder="名称"></el-input>
															<span>-</span>
															<el-input :name="item2.key1" v-model="item2.value" placeholder="值"></el-input>
														</p>
														<p>
															<span class="el-icon-circle-plus-outline" @click="addDiction(item1.formId)"></span>
															<span class="el-icon-delete" @click="removeDiction(item1.formId, item2.formId)" v-if="index > 0"></span>
														</p>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<!-- 单选按钮组 -->
									<div class="contentOne" v-show="leftIndex == 8" v-if="item1.status == leftIndex">
										<div id class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p class="select">
												<span>选项</span>
												<span @click="dialogFormVisible = true">字典选择</span>
											</p>
											<div class="opyionClass">
												<ul>
													<li v-for="(item2, index) in item1.options" :key="index">
														<p>
															<el-input :name="item2.key" v-model="item2.label" placeholder="名称"></el-input>
															<span>-</span>
															<el-input :name="item2.key1" v-model="item2.value" placeholder="值"></el-input>
														</p>
														<p>
															<span class="el-icon-circle-plus-outline" @click="addDiction(item1.formId)"></span>
															<span class="el-icon-delete" @click="removeDiction(item1.formId, item2.formId)" v-if="item2.formId != 1"></span>
														</p>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<!-- 复选框组 -->
									<div class="contentOne" v-show="leftIndex == 9" v-if="item1.status == leftIndex">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p class="select">
												<span>选项</span>
												<span @click="dialogFormVisible = true">字典选择</span>
											</p>
											<div class="opyionClass">
												<ul>
													<li v-for="(item2, index) in item1.options" :key="index">
														<p>
															<el-input :name="item2.key" v-model="item2.label" placeholder="名称"></el-input>
															<span>-</span>
															<el-input :name="item2.key1" v-model="item2.value" placeholder="值"></el-input>
														</p>
														<p>
															<span class="el-icon-circle-plus-outline" @click="addDiction(item1.formId)"></span>
															<span class="el-icon-delete" @click="removeDiction(item1.formId, item2.formId)" v-if="index > 0"></span>
														</p>
													</li>
												</ul>
											</div>
											<!--选择字典  -->
											<!-- <el-dialog title="选择字典" :visible.sync="dialogFormVisible3" :append-to-body="true" width="20%">
												<div class="selectClass">
													<el-select v-model="dictValue" placeholder="请选择">
														<el-option
															v-for="(diction, index) in dictOptions"
															:key="index"
															:label="diction.dictName"
															:value="diction.dictValue"
														></el-option>
													</el-select>
												</div>
												<div slot="footer" class="dialog-footer"><el-button type="primary" @click="checkClick(item1.formId)">确 定</el-button></div>
											</el-dialog> -->
										</div>
									</div>
									<!-- 图片上传 -->
									<div class="contentOne" v-show="leftIndex == 10" v-if="item1.status == leftIndex">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p>下载样式</p>
											<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" multiple :limit="1">
												<el-button size="small" type="primary">图片上传</el-button>
											</el-upload>
										</div>
									</div>
									<!-- 文件上传 -->
									<div class="contentOne" v-show="leftIndex == 11" v-if="item1.status == leftIndex">
										<div class="editContent">
											<p>标签</p>
											<el-input :name="item1.key" v-model="item1.label" placeholder="请输入标签"></el-input>
											<p>名称</p>
											<el-input :name="item1.key" v-model="item1.name" placeholder="请输入名称"></el-input>
											<p>提示语</p>
											<el-input :name="item1.key" v-model="item1.hint" placeholder="请输入提示语"></el-input>
											<p>是否必填</p>
											<el-checkbox :name="item1.key" v-model="item1.required">必填</el-checkbox>
											<p>下载样式</p>
											<el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" multiple :limit="1">
												<el-button size="small" type="primary">文件上传</el-button>
											</el-upload>
										</div>
									</div>
									<!--选择字典  -->
									<el-dialog title="选择字典" :visible.sync="dialogFormVisible" :append-to-body="true" width="20%">
										<div class="selectClass">
											<el-select v-model="dictValue" placeholder="请选择">
												<el-option v-for="(diction, index) in dictOptions" :key="index" :label="diction.dictName" :value="diction.dictValue"></el-option>
											</el-select>
										</div>
										<div slot="footer" class="dialog-footer"><el-button type="primary" @click="optionClick(item1.formId)">确 定</el-button></div>
									</el-dialog>
								</div>
							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
			<!-- 右侧 -->
			<div class="rightTabs">
				<!-- tabs -->
				<div class="activeTabs">
					<ul :class="{ overClass: overShow }">
						<li v-for="(item, index) in tabsList.formDesignPageList" :key="index" :class="{ tabsActive: activeIndex == index }" @click="tabsClick(index)">
							<input type="text" :name="item.key" v-model="item.name" />
							<i class="el-icon-close" @click="removeTabs(item.id)"></i>
						</li>
					</ul>
					<p>
						<img v-show="imgShow" @click="showClick" src="../../../../../public/images/top.png" alt="" />
						<img v-show="imgShow1" @click="showClick" src="../../../../../public/images/bottom.png" alt="" />
					</p>
				</div>
				<!-- tabs对应的div -->
				<div class="tabsContent">
					<div v-for="(item, index) in tabsList.formDesignPageList" :key="index" v-show="activeIndex == index" class="contentAll">
						<div
							class="forContent"
							v-for="(item1, index) in item.formDesignFieldList"
							:key="index"
							:class="{ forActive: forIndex == index }"
							@click="forClick(index, item1.formId, item1.status)"
							@mouseenter="isShow(item1.formId)"
							@mouseleave="isnotShow"
						>
							<!-- 分段 -->
							<div class="conentFirst" v-if="item1.status == 0">
								<div>
									<p>{{ item1.label }}</p>
								</div>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 文本 -->
							<div class="contentSecond" v-if="item1.status == 1">
								<el-input type="textarea" :name="item1.key" v-model="item1.label" placeholder="请填写内容" label-width="80%"></el-input>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 文本输入框 -->
							<div class="contentThrid" v-if="item1.status == 2">
								<p>{{ item1.label }}</p>
								<el-input type="text" :placeholder="item1.hint" :minlength="item1.minLength" :maxlength="item1.maxLength"></el-input>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 密码输入框 -->
							<div class="contentThrid" v-if="item1.status == 3">
								<p>{{ item1.label }}</p>
								<el-input type="password" :placeholder="item1.hint" :minlength="item1.minLength" :maxlength="item1.maxLength"></el-input>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 数值输入框 -->
							<div class="contentThrid" v-if="item1.status == 4">
								<p>{{ item1.label }}</p>
								<el-input type="number" :placeholder="item1.hint"></el-input>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 日期选择器 -->
							<div class="contentThrid" v-if="item1.status == 5">
								<p>{{ item1.label }}</p>
								<el-input type="text" :placeholder="item1.hint"></el-input>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 多行文本输入框 -->
							<div class="contentSecond1" v-if="item1.status == 6">
								<p>{{ item1.label }}</p>
								<el-input type="textarea" :placeholder="item1.hint" label-width="80%" :minlength="item1.minLength" :maxlength="item1.maxLength"></el-input>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 下拉列表 -->
							<div class="contentFourth" v-if="item1.status == 7">
								<p>{{ item1.label }}</p>
								<el-select v-model="item1.value" :placeholder="item1.hint">
									<el-option v-for="(item2, index) in item1.options" :key="index" :label="item2.label" :value="item2.value"></el-option>
								</el-select>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 单选框组 -->
							<div class="contentFourth" v-if="item1.status == 8">
								<p>{{ item1.label }}</p>
								<el-radio-group v-model="item1.value">
									<el-radio v-for="(item2, index) in item1.options" :key="index" :label="item2.label">{{ item2.label }}</el-radio>
								</el-radio-group>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 多选框组 -->
							<div class="contentFourth" v-if="item1.status == 9">
								<p>{{ item1.label }}</p>
								<el-checkbox-group v-model="item1.value">
									<el-checkbox v-for="(item2, index) in item1.options" :key="index" :label="item2.label">{{ item2.label }}</el-checkbox>
								</el-checkbox-group>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 图片上传 -->
							<div class="contentFifth" v-if="item1.status == 10">
								<p>{{ item1.label }}</p>
								<div>
									<img src="../../../../../public/images/uploadImg.png" alt="" />
									<span>上传图片</span>
								</div>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
							<!-- 文件上传 -->
							<div class="contentFifth" v-if="item1.status == 11">
								<p>{{ item1.label }}</p>
								<div>
									<img src="../../../../../public/images/uploadImg.png" alt="" />
									<span>上传文件</span>
								</div>
								<div class="hoverCalss" v-show="hoverShowIndex == item1.formId">
									<i class="el-icon-delete" @click.stop="deleteContent(item1.formId)"></i>
									<i class="el-icon-sort-down" @click.stop="downData(index)"></i>
									<i class="el-icon-sort-up" @click.stop="upData(index)"></i>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['adminData'],
	components: {},
	data() {
		return {
			tabsNum: 0,
			forIndex: 0,
			activeIndex: 0,
			aInex: 0,
			contentIndex: 0,
			contentId: 0,
			activeName: 'first',
			leftIndex: 0,
			imgShow: false,
			imgShow1: true,
			overShow: true,
			ulTabs: ['分段', '文本', '文本输入框', '密码输入框', '数值输入框', '日期选择器', '多行文本输入框', '下拉列表', '单选按钮组', '复选框组', '图片上传', '文件上传'],
			ulList: [],
			labelNum: 0,
			label: '', //文本
			pulldownOptions: [
				//下拉列表
				{
					pulldownValue: '选项1',
					pulldownName: '黄金糕'
				}
			],
			pulldownValue: '',
			radio: 3,
			minLength1: 0,
			maxLength1: 30,
			minLength2: 0,
			maxLength2: 30,
			minLength3: 0,
			maxLength3: 30,
			dialogFormVisible: false, //字典弹框
			dialogFormVisible2: false, //字典弹框
			dialogFormVisible3: false, //字典弹框
			optionCount: 0,
			hoverShowIndex: null,
			dictOptions: [],
			dictValue: '',
			optionList: [],
			formId: 1,
			formCount: 1,
			tabsList: {
				id: '',
				keywords: 'activeInput' + 1,
				title: '',
				formDesignPageList: []
			}
		};
	},
	watch: {
		// 父传子时，数据如果要打印或处理，要在watch中
		adminData(val) {
			window.console.log(val)
			this.tabsList = {
				id: val.id,
				keywords: val.keywords,
				title: val.title,
				formDesignPageList: []
			};
			for (let i = 0; i < val.formDesignPageList.length; i++) {
				this.tabsList.formDesignPageList.push({
					sort: 0,
					id: val.formDesignPageList[i].id,
					formId: i,
					keywords: 'activeInput' + i,
					name: val.formDesignPageList[i].name,
					formDesignFieldList: []
				});
			}
			window.console.log(this.tabsList);
			var statusE
			for (var i = 0; i < val.formDesignPageList.length; i++) {
				for (var j = 0; j < val.formDesignPageList[i].formDesignFieldList.length; j++) {
					if (val.formDesignPageList[i].formDesignFieldList[j].type == "segment") {
						statusE=0
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'text') {
						statusE=1
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'inputtext') {
						statusE=2
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'inputpassword') {
						statusE=3
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'inputnumber') {
						statusE=4
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == ' inputdate') {
						statusE=5
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'textarea') {
						statusE=6
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'dropdown') {
						statusE=7
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'radiobuttons') {
						statusE=8
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'checkboxes') {
						statusE=9
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'imageupload') {
						statusE=10
					} else if (val.formDesignPageList[i].formDesignFieldList[j].type == 'fileupload') {
						statusE=11
					}
					
					this.tabsList.formDesignPageList[i].formDesignFieldList.push({
						// key: 'contentKey' + contentToatl,
						status: statusE,
						id: val.formDesignPageList[i].formDesignFieldList[j].id,
						type:  val.formDesignPageList[i].formDesignFieldList[j].type, //分段
						formId:  j,
						name: val.formDesignPageList[i].formDesignFieldList[j].name,
						hint: val.formDesignPageList[i].formDesignFieldList[j].hint, //提示语hint
						label: val.formDesignPageList[i].formDesignFieldList[j].label, //label
						units: '', //单位
						minLength: val.formDesignPageList[i].formDesignFieldList[j].minLength, //最大长度
						maxLength: val.formDesignPageList[i].formDesignFieldList[j].maxLength, //最短长度
						required: val.formDesignPageList[i].formDesignFieldList[j].required, //是否必填required
						view: '',
						samples: '', //样例
						tables: '', //表格
						sort: 0,
						options: [],
						value: '' //选中的
					});
					for(var a=0;a<val.formDesignPageList[i].formDesignFieldList[j].options.length;a++){
						this.tabsList.formDesignPageList[i].formDesignFieldList[j].options.push({
							formId: val.formDesignPageList[i].formDesignFieldList[j].id,
							key: 'optionInput' + val.formDesignPageList[i].formDesignFieldList[j].id,
							label: val.formDesignPageList[i].formDesignFieldList[j].options[a].label,
							key1: 'textCountInput' + val.formDesignPageList[i].formDesignFieldList[j].id,
							value: val.formDesignPageList[i].formDesignFieldList[j].options[a].value
						})
					}
				}
			}
			// window.console.log(val);
			// window.console.log(this.tabsList);
		}

	},
	created() {
	},
	mounted() {
		
	},
	methods: {
		// 获取字典类型
		getTypeList() {
			this.$post('api/dict//getDictType')
				.then(res => {
					window.console.log(res);
					for (var i = 0; i < res.data.length; i++) {
						this.dictOptions.push({
							dictName: res.data[i],
							dictValue: i
						});
					}
					// this.dictOptions=res.data
					window.console.log(this.dictOptions);
				})
				.catch(e => {
					window.console.log(e);
				});
		},
		optionClick(id) {
			//getDiction
			var that = this;
			that.dialogFormVisible = true;
			window.console.log(id);
			window.console.log(this.dictValue);
			window.console.log(this.dictOptions[this.dictValue].dictName);
			var type = this.dictOptions[this.dictValue].dictName;
			let data = new FormData();
			data.append('type', type);
			this.$post('api/dict/listData', data)
				.then(res => {
					window.console.log(res);
					var data = res.data.list;
					for (let i = 0; i < that.tabsList.formDesignPageList.length; i++) {
						for (let j = 0; j < that.tabsList.formDesignPageList[i].formDesignFieldList.length; j++) {
							window.console.log(id + 'id' + that.tabsList.formDesignPageList[i].formDesignFieldList[j].formId);
							if (id == that.tabsList.formDesignPageList[i].formDesignFieldList[j].formId) {
								that.tabsList.formDesignPageList[i].formDesignFieldList[j].options = [];
								for (var a = 0; a < data.length; a++) {
									// that.tabsList.formDesignPageList
									that.tabsList.formDesignPageList[i].formDesignFieldList[j].options.push({
										formId: data[a].id,
										key: 'optionInput' + data[a].id,
										label: data[a].label,
										key1: 'textCountInput' + data[a].id,
										value: data[a].value
									});
								}
							}
						}
					}
					this.dialogFormVisible = false;
					this.dictValue = '';
				})
				.catch(e => {
					window.console.log(e);
				});
		},

		// 点击添加字段中的tab键出现对应的div
		leftTabClick(e) {
			var that = this;
			window.console.log(that.tabsList.formDesignPageList.length);
			that.activeName = 'second';
			that.leftIndex = e;
			that.aInex = e;
			var contentToatl = ++that.contentIndex;
			var inputType;
			var minLeg;
			var maxLeg;

			if (that.tabsList.formDesignPageList.length == 0) {
				this.$message({
					message: '请先添加分页',
					type: 'warning'
				});
			}
			if (e == 0) {
				minLeg = this.minLength1;
				maxLeg = this.maxLength1;
				inputType = 'segment';
			} else if (e == 1) {
				minLeg = this.minLength2;
				maxLeg = this.maxLength2;
				inputType = 'text';
			} else if (e == 2) {
				minLeg = this.minLength2;
				maxLeg = this.maxLength2;
				inputType = 'inputtext';
			} else if (e == 3) {
				minLeg = this.minLength2;
				maxLeg = this.maxLength2;
				inputType = 'inputpassword';
			} else if (e == 4) {
				inputType = 'inputnumber';
			} else if (e == 5) {
				inputType = ' inputdate';
			} else if (e == 6) {
				minLeg = this.minLength3;
				maxLeg = this.maxLength3;
				inputType = 'textarea';
			} else if (e == 7) {
				that.dictOptions = [];
				that.getTypeList();
				inputType = 'dropdown';
			} else if (e == 8) {
				that.dictOptions = [];
				that.getTypeList();
				inputType = 'radiobuttons';
			} else if (e == 9) {
				that.dictOptions = [];
				that.getTypeList();
				inputType = 'checkboxes';
			} else if (e == 10) {
				inputType = 'imageupload';
			} else if (e == 11) {
				inputType = 'fileupload';
			}
			// window.console.log(that.ulTabs)
			for (let i = 0; i < that.tabsList.formDesignPageList.length; i++) {
				if (that.activeIndex == i) {
					that.contentId = contentToatl; //当每次点击左侧时出现对应的内容(当id还没有时让contentId为点击左侧的下标)
					//判断当右侧点击的tabs下标和i相同（也就是数组的index）
					window.console.log(that.tabsList.formDesignPageList);
					that.tabsList.formDesignPageList[i].formDesignFieldList.push({
						key: 'contentKey' + contentToatl,
						status: e,
						id: '',
						type: inputType, //分段
						formId: contentToatl,
						name: inputType + '_' + contentToatl,
						hint: '', //提示语hint
						label: '未命名', //label
						units: '', //单位
						minLength: minLeg, //最大长度
						maxLength: maxLeg, //最短长度
						required: true, //是否必填required
						view: '',
						samples: '', //样例
						tables: '', //表格
						sort: 0,
						options: [
							{
								formId: 1,
								key: 'optionInput1',
								label: '选项1',
								key1: 'textCountInput1',
								value: '1'
							},
							{
								formId: 2,
								key: 'optionInput2',
								label: '选项2',
								key1: 'textCountInput2',
								value: '2'
							}
						],
						value: '' //选中的
					});
				}
			}
			window.console.log(that.tabsList);
		},
		// 服务人员模块、字典数据模块完成、表单模块分页、添加字段、编辑字段完成
		// 分页多的时候显示隐藏的按钮
		showClick() {
			if (this.imgShow == false) {
				this.imgShow = true;
				this.imgShow1 = false;
				this.overShow = false;
			} else if (this.imgShow == true) {
				this.imgShow = false;
				this.imgShow1 = true;
				this.overShow = true;
			}
		},
		// 点击切换tabs页
		tabsClick(e) {
			this.activeIndex = e;
			this.imgShow = false;
			this.imgShow1 = true;
			this.overShow = true;
		},
		// 增加分页(右侧)
		addPage() {
			var that = this;
			let newTabName = ++that.tabsNum;
			that.tabsList.formDesignPageList.push({
				sort: 0,
				id: '',
				formId: newTabName,
				keywords: 'activeInput' + newTabName,
				name: '新页面',
				formDesignFieldList: []
			});
			window.console.log(that.tabsList);
		},
		// 删除分页
		removeTabs(id) {
			var that = this;
			window.console.log(id);
			that.tabsList.formDesignPageList.some((item, i) => {
				if (item.formId == id) {
					that.tabsList.formDesignPageList.splice(i, 1); //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
					return true;
				}
			});
		},
		// 点击右侧栏的数据对应左侧栏
		forClick(e, id, status) {
			var that = this;
			that.activeName = 'second'; //编辑字段页面出现
			that.forIndex = e;
			that.contentId = id;
			// 判断点击右侧时显示对应的左侧
			if (status == 0) {
				that.leftIndex = 0;
			} else if (status == 1) {
				that.leftIndex = 1;
			} else if (status == 2) {
				that.leftIndex = 2;
			} else if (status == 3) {
				that.leftIndex = 3;
			} else if (status == 4) {
				that.leftIndex = 4;
			} else if (status == 5) {
				that.leftIndex = 5;
			} else if (status == 6) {
				that.leftIndex = 6;
			} else if (status == 7) {
				that.leftIndex = 7;
			} else if (status == 8) {
				that.leftIndex = 8;
			} else if (status == 9) {
				that.leftIndex = 9;
			} else if (status == 10) {
				that.leftIndex = 10;
			} else if (status == 11) {
				that.leftIndex = 11;
			}
		},

		handleChange1(value) {
			this.minLength1 = value;
			// window.console.log(this.minLength1);
		},
		handleChange2(value) {
			this.maxLength1 = value;
			// window.console.log(this.maxLength1);
		},
		handleChange3(value) {
			this.minLength2 = value;
			// window.console.log(value);
		},
		handleChange4(value) {
			this.maxLength2 = value;
			// window.console.log(value);
		},
		handleChange5(value) {
			this.minLength3 = value;
			// window.console.log(value);
		},
		handleChange6(value) {
			this.maxLength3 = value;
			// window.console.log(value);
		},
		// 增加选项(下拉列表含字典选择的页面)
		addDiction(id) {
			window.console.log(id);
			var that = this;
			var newI = ++that.optionCount;
			var newIndex = newI + 2;
			for (let i = 0; i < that.tabsList.formDesignPageList.length; i++) {
				window.console.log(that.tabsList.formDesignPageList[i].formId);
				window.console.log(that.tabsList);
				for (let j = 0; j < that.tabsList.formDesignPageList[i].formDesignFieldList.length; j++) {
					window.console.log(that.tabsList.formDesignPageList[i].formDesignFieldList[j].formId);
					if (id == that.tabsList.formDesignPageList[i].formDesignFieldList[j].formId) {
						that.tabsList.formDesignPageList[i].formDesignFieldList[j].options.push({
							formId: newI + 2,
							key: 'optionInput' + newIndex,
							label: '',
							key1: 'textCountInput' + newIndex,
							value: ''
						});
					}
				}
			}
		},
		// 删除选项(含字典选择的页面)
		removeDiction(id1, id) {
			var that = this;
			window.console.log(id1);
			for (let i = 0; i < that.tabsList.formDesignPageList.length; i++) {
				// if (id1 == that.tabsList.formDesignPageList[i].id) {
				for (let j = 0; j < that.tabsList.formDesignPageList[i].formDesignFieldList.length; j++) {
					if (id1 == that.tabsList.formDesignPageList[i].formDesignFieldList[j].formId) {
						that.tabsList.formDesignPageList[i].formDesignFieldList[j].options.some((item, a) => {
							if (item.formId == id) {
								that.tabsList.formDesignPageList[i].formDesignFieldList[j].options.splice(a, 1); //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
								return true;
							}
						});
					}
				}
				// }
			}
		},

		// hover(调整位置，删除)
		// 右侧内容hover进入(出现调整位置，删除)
		isShow(id) {
			this.hoverShowIndex = id;
		},
		// 右侧内容hover离开(隐藏调整位置，删除)
		isnotShow() {
			this.hoverShowIndex = null;
		},
		// 右侧内容hover进入点击删除
		deleteContent(id) {
			var that = this;
			window.console.log(id);
			for (let i = 0; i < that.tabsList.formDesignPageList.length; i++) {
				that.tabsList.formDesignPageList[i].formDesignFieldList.some((item, a) => {
					if (item.formId == id) {
						that.tabsList.formDesignPageList[i].formDesignFieldList.splice(a, 1); //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
						return true;
					}
				});
			}
			window.console.log(that.tabsList);
		},

		// 右侧内容hover进入点击上移
		upData(index) {
			var that = this;
			for (let i = 0; i < that.tabsList.formDesignPageList.length; i++) {
				// 当在最顶端时点击无效return
				if (index == 0) {
					return;
				}
				let temp = that.tabsList.formDesignPageList[i].formDesignFieldList[index - 1];
				this.$set(that.tabsList.formDesignPageList[i].formDesignFieldList, index - 1, that.tabsList.formDesignPageList[i].formDesignFieldList[index]);
				this.$set(that.tabsList.formDesignPageList[i].formDesignFieldList, index, temp);
			}
		},
		// 右侧内容hover进入点击下移
		downData(index) {
			var that = this;
			for (let i = 0; i < that.tabsList.formDesignPageList.length; i++) {
				// 当在最底端时点击无效return
				if (index == that.tabsList.formDesignPageList[i].formDesignFieldList.length - 1) {
					return;
				}
				let temp = that.tabsList.formDesignPageList[i].formDesignFieldList[index + 1];
				this.$set(that.tabsList.formDesignPageList[i].formDesignFieldList, index + 1, that.tabsList.formDesignPageList[i].formDesignFieldList[index]);
				this.$set(that.tabsList.formDesignPageList[i].formDesignFieldList, index, temp);
			}
		},
		// 关闭页面
		closeAdmin() {
			this.$bus.$emit('isAdd', false);
		},
		// 提交表单
		submitForm() {
			var that = this;
			this.$bus.$emit('isAdd', false);
			that.formCount = ++that.formId;
			window.console.log(that.tabsList);
			this.$post('api/form/save', that.tabsList)
				.then(res => {
					window.console.log(res);
					if (res.success == 1) {
						this.$message({
							message: res.message,
							type: 'success'
						});
					}else{
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				})
				.catch(e => {
					window.console.log(e);
				});
		}
	}
};
</script>

<style scoped="scoped">
.saveChage {
	width: 90px;
	background-color: #052a54;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 0;
	color: #fff;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	margin: 30px auto;
}
.forActive {
	background-color: #eee;
}
.contentAll {
	margin-bottom: 20px;
}
.contentAll .forContent {
	width: calc(96%- 40px);
	padding: 8px 6px;
	margin-bottom: 10px;
	/* background-color: #eee; */
}
.contentAll .forContent > div {
	position: relative;
}

.conentFirst:first-of-type > div {
	padding: 6px 20px;
}
.conentFirst > div > p {
	padding: 6px 20px;
	background-color: #fff;
}
.contentSecond {
	padding: 8px 6px 8px 15% !important;
}
.contentSecond1 {
	display: flex;
	align-items: center;
}
.contentSecond1 > p {
	width: 15%;
	text-align: center;
}
.contentThrid {
	display: flex;
	align-items: center;
}
.contentThrid .el-input {
	width: 40%;
	/* margin-left:10px; */
}
.contentThrid > p {
	width: 15%;
	/* padding: 0 20px; */
	text-align: center;
}
.contentFourth {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 4px 0;
}
.contentFourth > p {
	text-align: center;
	width: 15%;
}
.contentFourth .el-select {
	width: 85%;
}
.contentFourth .el-radio-group {
	width: 85%;
}
.contentFourth .el-checkbox-group {
	width: 85%;
}
.contentFifth {
	display: flex;
	align-items: center;
}
.contentFifth > p {
	width: 15%;
	text-align: center;
}
.contentFifth > div:first-of-type {
	width: 110px;
	background-color: #052a54;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 6px 0;
	color: #fff;
	border-radius: 4px;
	font-size: 11px;
	cursor: pointer;
}
.contentFifth > div > img {
	width: 24px;
}
#container {
	background-color: #fff;
	overflow-y: scroll;
	height: 620px;
	/* padding:20px; */
}
ul {
	list-style: none;
}
#container .dialogHeader {
	background-color: #eee;
	height: 36px;
	padding: 6px;
	position: relative;
	/* display: flex;
	align-items: center; */
}
#container .dialogHeader > li {
	width: 80px;
	height: 36px;
	line-height: 36px;
	background-color: #052a54;
	border-radius: 4px;
	text-align: center;
	font-size: 13px;
	color: #f3f3f3;
	position: absolute;
	cursor: pointer;
	user-select: none;
}
#container .dialogHeader > li:nth-of-type(2) {
	right: 10%;
}
#container .dialogHeader > li:nth-of-type(3) {
	right: 6px;
}
#container .contentClass {
	margin-top: 20px;
	display: flex;
}
#container .contentClass .leftTabs {
	/* border:1px solid red; */
	width: 28%;
	box-sizing: border-box;
}
#container .contentClass .leftTabs .el-tabs .el-tab-pane {
	/* border:1px solid red; */
}
.tabsUl {
	text-align: center;
}
.tabsUl li {
	width: 60%;
	height: 36px;
	line-height: 36px;
	font-size: 13px;
	background-color: #052a54;
	color: #f3f3f3;
	margin: 8px auto 0;
	border-radius: 4px;
	cursor: pointer;
}
.tabsUl li i {
	margin-right: 6px;
}
.editContent {
	/* height: 600px; */
	padding: 0 20px;
}
.editContent .contentOne {
	margin-bottom: 50px;
}
.editContent .contentOne .contentChild > p {
	font-size: 12px;
	font-weight: bold;
	color: #000;
	padding: 6px 0;
	border-bottom: 1px solid #dddddd;
	margin: 10px 0;
}
.editContent .contentOne > p {
	font-size: 12px;
	font-weight: bold;
	color: #000;
	padding: 6px 0;
	border-bottom: 1px solid #dddddd;
	margin: 10px 0;
}
#container .contentClass .rightTabs {
	/* border: 1px solid red; */
	width: 72%;
	box-sizing: border-box;
	margin-bottom: 30px;
}
.rightTabs .activeTabs {
	height: 40px;
	width: 100%;
	position: relative;
}
.overClass {
	overflow: hidden;
}
.rightTabs .activeTabs > p {
	width: 4%;
	height: 100%;
	background-color: #fff;
	box-sizing: border-box;
	border: 1px solid #eee;
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 10;
	position: absolute;
	right: 0;
	top: 0;
}
.rightTabs .activeTabs > p > img {
	width: 20px;
	height: 20px;
	cursor: pointer;
}
.rightTabs .activeTabs > ul {
	width: 96%;
	list-style: none;
	height: 40px;
	display: flex;
	justify-content: start;
	flex-wrap: wrap;
	box-sizing: border-box;
	position: absolute;
	top: 0;
	left: 0;
	background-color: #eee;
}
.rightTabs .activeTabs > ul > li {
	width: 25%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	box-sizing: border-box;
	background-color: #eee;
}
.tabsActive {
	background-color: #fff !important;
	border-left: 1px solid #cfcfcf;
	border-right: 1px solid #cfcfcf;
	position: relative;
}
.tabsActive::before {
	content: '';
	width: 100%;
	height: 1.5px;
	background-color: #e14f4f;
	position: absolute;
	left: 0;
	top: 0;
}
.rightTabs .activeTabs > ul > li > input {
	display: inline-block;
	width: 80%;
	height: 26px;
	background: none;
	outline: none;
	border: none;
	text-align: center;
}
.rightTabs .activeTabs > ul > li > i {
	font-size: 20px;
	color: #a1a1a1;
	font-size: 13px;
	padding: 2px;
}
.rightTabs .activeTabs > ul > li > i:hover {
	color: #fff;
	background-color: #ff5722;
	border-radius: 2px;
}

.editContent > p {
	font-size: 12px;
	font-weight: bold;
	color: #000;
	padding: 6px 0;
	border-bottom: 1px solid #dddddd;
	margin: 10px 0;
}
.editContent .lengthClass {
	display: flex;
	align-items: center;
}
.editContent .lengthClass > span {
	margin: 0 4px;
}
.saveChage {
	width: 90px;
	background-color: #052a54;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 0;
	color: #fff;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	margin: 30px auto;
}
.editContent > p {
	font-size: 12px;
	font-weight: bold;
	color: #000;
	padding: 6px 0;
	border-bottom: 1px solid #dddddd;
	margin: 10px 0;
}
.editContent .select {
	display: flex;
	align-items: center;
	position: relative;
}
.editContent .select > span:nth-of-type(2) {
	display: inline-block;
	color: #fff;
	font-size: 11px;
	background-color: #052a54;
	width: 80px;
	text-align: center;
	padding: 4px 0;
	border-radius: 4px;
	position: absolute;
	right: 0;
	cursor: pointer;
}

.editContent .opyionClass ul {
	list-style: none;
}
.editContent .opyionClass ul > li {
	display: flex;
	align-items: center;
	margin-bottom: 6px;
}
.editContent .opyionClass ul > li > p {
	display: flex;
	align-items: center;
}
.editContent .opyionClass ul > li > p .el-input {
	width: 80px;
}
.editContent .opyionClass ul > li > p > span {
	margin: 0 10px;
}
.editContent .opyionClass ul > li > p:nth-of-type(2) > span {
	width: 20px;
	cursor: pointer;
	font-size: 20px;
}
.editContent .opyionClass ul > li > p:nth-of-type(2) > span:first-of-type:hover {
	color: green;
}
.editContent .opyionClass ul > li > p:nth-of-type(2) > span:nth-of-type(2):hover {
	color: red;
}
.selectClass {
	height: 300px;
	/* overflow-y: scroll; */
}
.selectClass .el-select {
	width: 100%;
}
.saveChage {
	width: 90px;
	background-color: #052a54;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px 0;
	color: #fff;
	border-radius: 4px;
	font-size: 12px;
	cursor: pointer;
	margin: 30px auto;
}
/* .conentFirst, .contentSecond, .contentThrid, .contentFourth, .contentFifth, .contentSecond1{
	position: relative;
} */
.hoverCalss {
	position: absolute;
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	padding: 0 !important;
	height: 40px;
	/* border:1px solid red; */
}
.hoverCalss > i {
	font-size: 16px;
	cursor: pointer;
	color: #999;
}
.hoverCalss > i:hover {
	color: red;
}
.hoverCalss > i:first-of-type {
	display: block;
	text-align: center;
	margin-bottom: 4px;
}
.mainTitle {
	position: absolute;
	top: 14px;
	/* border:1px solid red; */
}
.mainTitle > input {
	font-size: 20px;
	border: none;
	outline: none;
}
</style>
